import clsx from 'clsx';
import { createPortal } from 'react-dom';

import s from './LanguageSwitcherDropdown.module.css';

export const LanguageSwitcherFlyout = ({ allLanguages, currentCode, onSelect, floatingRef, floatingStyles, ariaLabel }) => {
	return createPortal(
		<div
			ref={floatingRef}
			style={{ ...floatingStyles, zIndex: 1201 }}
			className={clsx('nav-dropdown', 'scrollbar-y', 'dropdown-navigation__companies', s.languagePanel)}
			role='menu'
			aria-label={ariaLabel}
			data-language-panel='true'
		>
			{allLanguages.map(({ code, label, flag, name }) => {
				const isActive = code === currentCode;

				return (
					<button
						key={code}
						type='button'
						className={clsx('list-item', s.langItem, isActive && 'list-item--active')}
						onClick={() => onSelect(code)}
						role='menuitem'
						aria-label={name}
						aria-current={isActive || undefined}
					>
						<span className={s.langFlag} role='img' aria-hidden='true'>
							{flag}
						</span>
						<span className='body-medium-sm list-item__text nav-dropdown__language-code'>{label}</span>
					</button>
				);
			})}
		</div>,
		document.body,
	);
};
